import { c as _c } from "react/compiler-runtime";
import { type TooltipRenderProps } from 'react-joyride';
export function CustomJoyrideTooltip(props) {
  const $ = _c(24);
  const {
    backProps,
    continuous,
    index,
    primaryProps,
    skipProps,
    step,
    tooltipProps
  } = props;
  let t0;
  if ($[0] !== step.title) {
    t0 = step.title && <h4 className="mb-2 pr-10 text-base font-semibold text-textPrimary sm:mb-3 sm:pr-8 sm:text-lg">{step.title}</h4>;
    $[0] = step.title;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      whiteSpace: "pre-wrap"
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== step.content) {
    t2 = <div style={t1} className="mb-3 text-sm leading-relaxed text-textSecondary sm:mb-4">{step.content}</div>;
    $[3] = step.content;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== skipProps) {
    t3 = <button className="rounded-md px-3 py-1.5 text-sm text-textSecondary transition-colors hover:bg-background-primary hover:text-textPrimary" {...skipProps}>{skipProps.title}</button>;
    $[5] = skipProps;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== backProps || $[8] !== index) {
    t4 = index > 0 && <button className="rounded-md px-3 py-1.5 text-sm text-textSecondary transition-colors hover:bg-background-primary hover:text-textPrimary" {...backProps}>{backProps.title}</button>;
    $[7] = backProps;
    $[8] = index;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== continuous || $[11] !== primaryProps) {
    t5 = continuous && <button className="rounded-md bg-primary px-3 py-1.5 text-sm font-emphasis text-white transition-colors hover:bg-primary/90" {...primaryProps}>{primaryProps.title}</button>;
    $[10] = continuous;
    $[11] = primaryProps;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <div className="flex items-center gap-2">{t4}{t5}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t3 || $[17] !== t6) {
    t7 = <div className="flex items-center justify-between">{t3}{t6}</div>;
    $[16] = t3;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t0 || $[20] !== t2 || $[21] !== t7 || $[22] !== tooltipProps) {
    t8 = <div className="relative mx-2 w-[90vw] rounded-lg border border-ds-border-standard bg-background-secondary p-3 shadow-xl sm:mx-0 sm:p-4 md:max-w-sm" {...tooltipProps}>{t0}{t2}{t7}</div>;
    $[19] = t0;
    $[20] = t2;
    $[21] = t7;
    $[22] = tooltipProps;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
}